export enum MedicalLicenseTypes {
    PROVINCIAL = 1,
    NACIONAL = 2,
    INDEFINIDO = 3,
}